import {
    decodeDelimitedArray,
    encodeDelimitedArray,
    withDefault,
} from 'use-query-params'

export const DashArrayParamCode = {
    encode: (array: (string | null)[] | null | undefined) =>
        encodeDelimitedArray(array, '-'),

    decode: (input: string | (string | null)[] | null | undefined) =>
        decodeDelimitedArray(input, '-'),
}

export const DashArrayParam = withDefault(DashArrayParamCode, [])

export function buildParams(
    data: Record<
        string,
        (string | null)[] | null | undefined | number | string | boolean
    >
) {
    const params = new URLSearchParams()

    Object.entries(data).forEach(([key, value]) => {
        if (!value) return

        if (Array.isArray(value)) {
            value.forEach(
                (value) => value && params.append(key, value.toString())
            )
        } else {
            params.append(key, String(value))
        }
    })

    return params.toString()
}

export function buildQuery(data: Record<string, (string | null)[]>) {
    const params = Object.keys(data).reduce(
        (acc: string, key: keyof typeof data): string => {
            if (!data[key].length) return acc

            return (
                acc +
                `${acc ? '&' : ''}${key}=${encodeDelimitedArray(
                    data[key],
                    '-'
                )}`
            )
        },
        ''
    )

    return params ? `?${params}` : ''
}

export const countFilters = (
    data: Record<
        string,
        (string | null)[] | null | undefined | string | number | boolean
    >
) => {
    return Object.entries(data).reduce((acc, [, value]) => {
        if (!value) return acc

        if (Array.isArray(value)) {
            return value.length + acc
        } else {
            return acc++
        }
    }, 0)
}
